/** Browser form validation mirrors the API's wiki name format; the server remains authoritative. */
export const WIKI_NAME_PATTERN = '[A-Za-z0-9][A-Za-z0-9._\\-]{0,99}';
